import * as actions from "Actions";
import * as api from "Api";

export const fetchHubPages = ({ limit }) => (dispatch, getState) => {
  const { token, navCommunity } = getState().auth;

  if (token === "") {
    return null;
  }
  return dispatch(
    actions.fetchPages(
      api.getPages({
        token,
        communityId: navCommunity.id,
        limit
      })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/page.js